export const scrollToElement = selector => {
  const editor = document.querySelector('.ck.ck-content');
  const element = document.querySelector(selector);
  const editorRect = editor.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  const start = editor.scrollTop;
  const end = editor.scrollTop + elementRect.top - editorRect.top - 25;
  const duration = 800;
  let startTime = null;
  const animateScroll = timestamp => {
    if (!startTime) startTime = timestamp;
    const progress = timestamp - startTime;
    const ease = easeInOutCubic(progress / duration);
    editor.scrollTo(0, start + (end - start) * ease);
    if (progress < duration) {
      requestAnimationFrame(animateScroll);
    }
  };
  const easeInOutCubic = t => {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  };
  requestAnimationFrame(animateScroll);
};